export default __webpack_public_path__ + "static/favicon-2933f95ac7a0f82d67f60ae215b62d03.png";